module.exports = __webpack_public_path__ + "img/kiwi.bf228ef1.jpg";